// extracted by mini-css-extract-plugin
module.exports = {"box":"box-1B1TUzNe","title_box":"title_box-2Z3ouAuL","pic_box":"pic_box-36cCaFfj"};